import {
  ChangeDetectionStrategy,
  Component,
  input,
  OnInit,
  output,
} from '@angular/core';
import { Account, AccountType } from '../../../core/models/account.model';

@Component({
  selector: 'lib-account-list',
  templateUrl: './account-list.component.html',
  styleUrls: ['./account-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AccountListComponent implements OnInit {
  accountList = input<Account[]>();
  // eslint-disable-next-line @angular-eslint/no-output-native
  cancel = output<void>();
  createAccount = output<void>();
  selectAccount = output<Account>();
  selectedAccount: Account;

  AccountType = AccountType;

  ngOnInit(): void {
    this.accountList().sort((a, b) => (a.country > b.country ? 1 : -1));
  }

  trackByFn(index: number) {
    return index;
  }
}
